var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-percent",
    "data-name": "Icon feather-percent",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2005",
    "data-name": "Trac\\xE9 2005",
    d: "M28.5,7.5l-21,21",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2006",
    "data-name": "Trac\\xE9 2006",
    d: "M13.5,9.75A3.75,3.75,0,1,1,9.75,6,3.75,3.75,0,0,1,13.5,9.75Z",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2007",
    "data-name": "Trac\\xE9 2007",
    d: "M30,26.25a3.75,3.75,0,1,1-3.75-3.75A3.75,3.75,0,0,1,30,26.25Z",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.d1a692741da9670b59be10ca20968121.svg";
export { ForwardRef as ReactComponent };